import CurrencyConfigSettingPanel from './currencyConfigSettingPanel.container';

export default CurrencyConfigSettingPanel;